import { render, staticRenderFns } from "./MitraGudangKompack.vue?vue&type=template&id=c6d74b30&"
import script from "./MitraGudangKompack.vue?vue&type=script&lang=js&"
export * from "./MitraGudangKompack.vue?vue&type=script&lang=js&"
import style0 from "./MitraGudangKompack.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports